<div class="referral-card">
  <div class="referral-card__head">
    <span class="referral-card__badge">
      <ion-icon name="gift-outline"></ion-icon>
    </span>
    <h3 class="referral-card__title">Invite a friend, you both win</h3>
  </div>

  <div class="referral-card__codebox">
    <div class="referral-card__code">
      <span class="referral-card__code-label">Your code</span>
      <span class="referral-card__code-value">{{ referralPromoCode }}</span>
    </div>
    <div class="referral-card__actions">
      <ion-button class="referral-card__icon-btn" fill="outline" aria-label="Copy referral code" (click)="copyCode()">
        <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
      </ion-button>
      <ion-button
        class="referral-card__icon-btn referral-card__icon-btn--share"
        fill="outline"
        aria-label="Share referral code"
        [disabled]="sharing"
        (click)="share()">
        @if (sharing) {
          <ion-spinner name="lines-sharp-small"></ion-spinner>
        }
        @if (!sharing) {
          <ion-icon slot="icon-only" name="share-outline"></ion-icon>
        }
      </ion-button>
    </div>
  </div>

  <div class="referral-card__value">
    <div class="referral-card__value-col">
      <span class="referral-card__value-who">Your friend</span>
      <span class="referral-card__value-amount">10% off</span>
    </div>
    <div class="referral-card__value-sep"></div>
    <div class="referral-card__value-col">
      <span class="referral-card__value-who">You, per friend</span>
      <span class="referral-card__value-amount">50,000 pts</span>
      <span class="referral-card__value-extra">+ 10% off your plan</span>
    </div>
  </div>
</div>
